<template>
  <v-row
    justify="end"
    class="mr-0">
    <v-dialog
      dark
      persistent
      v-model="addItemDialog"
      max-width="600px">
      <v-card>
        <v-card-title class="secondary">
          <span
            class="headline">
            {{ dataForModal ? $t(translation + '.edit') : $t(translation + '.add') }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                large
                icon
                v-bind="attrs"
                v-on="on"
                @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('tooltips.close') }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-on:submit.prevent>
              <v-row>
                <v-col
                  cols="12">
                  <v-text-field
                    v-model="form.name"
                    :label="$t(translation+'.name')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                  />
                </v-col>
                <v-col
                  cols="12">
                  <v-text-field
                    v-model="form.username"
                    :label="$t(translation+'.username')+'*'"
                    :rules="rules.required"
                    required
                  />
                </v-col>
                <v-col
                  v-if="dataForModal"
                  cols="12">
                  <v-switch
                    dense
                    v-model="change_password"
                    :label="$t(translation+'.change_password')"
                    color="red"
                    required
                  />
                </v-col>
                <v-col
                  v-if="!dataForModal || change_password"
                  cols="12">
                  <v-text-field
                    v-model="form.password"
                    :label="$t(translation+'.password')+'*'"
                    type="password"
                    required
                    :rules="rules.required_password_length"
                  />
                </v-col>
                <v-col
                  v-if="!dataForModal || change_password"
                  cols="12">
                  <v-text-field
                    v-model="form.verify_password"
                    :label="$t(translation+'.password_again')+'*'"
                    type="password"
                    required
                    :rules="rules.password_match"
                  />
                </v-col>
                <v-col
                  cols="10">
                  <v-text-field
                    v-model="form.cb_help_provider ? form.cb_help_provider.name : form.cb_help_provider"
                    :disabled="isEmptyObject(form.cb_help_provider)"
                    :label="$t(translation+'.helpProvider')"
                    readonly
                    required
                  />
                </v-col>
                <v-col
                  cols="2">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info mb-2"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="12">
                  <v-select
                    dark
                    v-model="form.roles"
                    :items="roles"
                    :loading="roles == null"
                    :label="$t('roles.choose')"
                    :rules="rules.required_array"
                    multiple
                    return-object
                    item-text="name"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{ $t('required_fields') }}</small>
        </v-card-text>
        <v-card-actions>
          <div
            class="flex-grow-1">
          </div>
          <v-btn
            class="info mr-2"
            dark
            :loading="loading"
            @click="dataForModal ? edit(apiEdit,form) : add(apiAdd)"
          >
            {{ dataForModal ? $t('edit') : $t('add') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------- Choose cb_help_user_type item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :singleSelect="singleSelect"
      :id="null"
      :api="apiChooseItem"
      :show-columns="showColumnsChooseItem"
      :translation="translationChooseItem"
      :headers="chooseItemHeaders"
      :dialogChooseItem="showDialogChooseItem"
      @closeChooseItemDialog="showDialogChooseItem=false"
      @itemChosenEvent="onItemChosenEvent"
    />
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import {add, edit, isEmptyObject, readTableDataPost} from "../../statics/DataTableFunctions";
import ChooseItemDialog from "./ChooseItemDialog";
import axios from "axios";

export default {
  props: {
    addItemDialog: false,
    dataForModal: null,
  },
  components: {
    'dialog-choose-item': ChooseItemDialog
  },
  name: "AddUser",
  data() {
    return {
      translation: 'users',
      translationChooseItem: 'cb.help_providers',
      showFields: true,
      isPartner: false,
      apiAdd: '/api/users/store',
      apiEdit: '/api/users/update',
      apiChooseItem: '/api/cb_help_providers/index',
      showDialogChooseItem: false,
      showColumnsChooseItem: [
        "id",
        "name"
      ],
      singleSelect: true,
      loading: false,
      roles: null,
      change_password: false,
      formError: {
        name: '',
        username: '',
        password: '',
        partner_id: null,
      },
      form: {
        name: '',
        username: '',
        password: null,
        verify_password: null,
        roles: [],
        cb_help_provider: null,
        cb_help_provider_id: null,
      },
      rules: {
        required: [
          v => !!v || this.$t('validation.field')
        ],
        required_array: [
          v => !!v || this.$t('validation.field'),
          v => !v || v.length >= 1 || this.$t('validation.roles'),
        ],
        required_length: [
          v => !!v || this.$t('validation.field'),
          v => v === '' || v.length > 1 || this.$t(this.translation + '.validation')
        ],
        required_password_length: [
          v => !!v || this.$t('validation.field'),
          v => this.form.password != undefined && this.form.password.length >= 4 || this.$t('short_password')
        ],
        password_match: [
          v => !!v || this.$t('validation.field'),
          v => v === this.form.password || this.$t('validation.password_match')
        ],
      },
      snackbar: {
        color: 'success',
        show: false,
        text: '',
        timeout: 3000,
      },
    }
  },
  methods: {
    add,
    edit,
    isEmptyObject,
    openDialogChooseItem() {
      this.showDialogChooseItem = true;
    },
    onItemChosenEvent(item) {
      this.form.cb_help_provider = item;
      this.form.cb_help_provider_id = item.id;
      this.showDialogChooseItem = false;
    },
    readRoles() {
      axios.post('/api/u_roles/index', {
        show_only_active: true,
        show_columns: [
          "id",
          "name",
        ]
      }).then(response => {
        this.roles = response.data;
      }).catch(error => {
        if (error.response.status === 401) {
          this.loading = false
          this.$swal.fire({
            type: 'info',
            title: "Info",
            text: this.$t('validation.session'),
          })
          this.$router.push('/login')
        } else {
          this.$swal.fire({
            type: 'error',
            title: this.$t('validation.error'),
            text: this.$t('validation.error'),
          })
        }
      });
    },
    closeDialog() {
      this.change_password = false;
      this.form = {
        name: '',
        username: '',
        password: null,
        verify_password: null,
        roles: null,
        cb_help_provider: null,
        cb_help_provider_id: null,
      }
      this.$refs.form.resetValidation()
      this.$emit('close')
    },
  },
  computed: {
    chooseItemHeaders() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.translationChooseItem + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        },
      ]
    },
  },
  watch: {
    change_password: function (val) {
      if(!val) {
        this.form.password = null;
        this.form.verify_password = null;
      }
    },
    dataForModal: function (val) {
      if (val) {
        this.form = {
          id: this.dataForModal.id,
          name: this.dataForModal.name,
          username: this.dataForModal.username,
          roles: this.dataForModal.roles,
          cb_help_provider: this.dataForModal.cb_help_provider,
          cb_help_provider_id: this.dataForModal.cb_help_provider ? this.dataForModal.cb_help_provider.id : null,
        }
      }
    }
  },
  created() {
    this.readRoles();
  }
}
</script>

<style scoped/>
